/* eslint-disable quotes */
const cssGenJsonFormater = () => {
  const colorJsonFormaterCssGen = (inputValue) => {
    let colorList = inputValue
      .replaceAll(/[ \n]/g, "")
      .replaceAll(/[ \t]/g, "")
      .replaceAll('"', "")
      .replaceAll(" ", "")
      .replaceAll("()", "")
      .replaceAll("}", "")
      .split(";");
    colorList = colorList.map((item) => {
      return {
        name: item.split(":")[0].replaceAll("$", "").replaceAll("-base", ""),
        hexValue: item.split(":")[1],
      };
    });
    const jsonColorVariables = colorList.filter((item) => {
      if (item.hexValue !== undefined) {
        return item;
      }
    });
    return { jsonColorVariables };
  };

  const typographyJsonFormaterCssGen = (inputValue) => {
    const sanitizedInputValue = inputValue
      .replaceAll(/[\n]/g, "")
      .replaceAll(/[\t]/g, "")
      .replaceAll('"', "")
      .replaceAll("()", "")
      .replaceAll("}", "");
    let typographyList = sanitizedInputValue
      .split("@mixin")
      .filter((item) => item !== "");
    let jsonTypographyVariables = [];
    typographyList.map((itemMixin) => {
      const mixinName = itemMixin.split("{")[0].replaceAll(" ", "");
      const mixinPropsString = itemMixin.split("{")[1];
      const mixinPropsStringArray = mixinPropsString
        .split(";")
        .filter((itemProps) => itemProps !== "");
      let mixinPropsObject = {};
      mixinPropsStringArray.map((item) => {
        if (item.includes("text-decoration") || item.includes("text-transform"))
          return;

        if (mixinName.includes("semibold") && item.includes("font-weight")) {
          mixinPropsObject = {
            ...mixinPropsObject,
            [`${item.split(":")[0]}`]: 600,
          };
        } else if (item.includes("line-height")) {
          mixinPropsObject = {
            ...mixinPropsObject,
            [`${item.split(":")[0]}`]: `${(
              parseInt(item.split(":")[1].replaceAll("px", "")) /
              parseInt(
                mixinPropsStringArray
                  .find(
                    (propsString) => propsString.split(":")[0] === "font-size"
                  )
                  .split(":")[1]
                  .replaceAll("px", "")
              )
            ).toFixed(2)}em`?.replaceAll(" ", ""),
          };
        } else if (item.includes("font-family")) {
          mixinPropsObject = {
            ...mixinPropsObject,
            [`${item.split(":")[0]}`]: item.split(":")[1].replace(" ", ""),
          };
        } else {
          mixinPropsObject = {
            ...mixinPropsObject,
            [`${item.split(":")[0]}`]: item.split(":")[1].replaceAll(" ", ""),
          };
        }
      });
      jsonTypographyVariables.push({
        name: mixinName,
        cssProps: mixinPropsObject,
      });
    });
    return { jsonTypographyVariables };
  };
  return { colorJsonFormaterCssGen, typographyJsonFormaterCssGen };
};

export default cssGenJsonFormater;
